import React, {useState} from 'react';
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import Info from "../../../components/Info";
import {Form, Input} from "semantic-ui-react";

const InnModal = ({onConfirm, setOpen, open, parcel}) => {
    const [recipientInn, setRecipientInn] = useState('');
    const [recipientCompanyName, setRecipientCompanyName] = useState('');
    return (
        <ConfirmModal
            className={'modal-confirm'}
            label={`Введите данные получателя`}
            setOpen={(open) => setOpen(open)}
            open={open}
            onConfirm={() => {
                onConfirm(recipientInn || parcel.recipientInn, recipientCompanyName || parcel.recipientCompanyName)
            }}
            closeBtnLabel={'Отменить'}
            confirmBtnLabel={'Сохранить'}
            disabledBtn={!((recipientInn || parcel.recipientInn) && (recipientCompanyName || parcel.recipientCompanyName))}
        >
            <div className='modal-information'>
                <Form>
                    {!parcel.recipientInn && <Form.Field>
                        <label>
                            ИНН получателя*
                            <Info
                                name={'ИНН получателя'}
                                text={'Это поле является обязательным по условиям ТК'}
                            />
                        </label>
                        <Input
                            fluid
                            name='recipientInn'
                            value={recipientInn || ''}
                            onChange={(e, {value}) => setRecipientInn(value)}
                        />
                    </Form.Field>}
                    {!parcel.recipientCompanyName && <Form.Field>
                        <label>
                            ЮЛ получателя*
                            <Info
                                name={'ЮЛ получателя'}
                                text={'Это поле является обязательным по условиям ТК'}
                            />
                        </label>
                        <Input
                            fluid
                            name='recipientCompanyName'
                            value={recipientCompanyName || ''}
                            onChange={(e, {value}) => setRecipientCompanyName(value)}
                        />
                    </Form.Field>}
                </Form>

            </div>
        </ConfirmModal>
    );
};

export default InnModal;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/innModal.jsx